import styled, { CSSProp } from 'styled-components'

export const CountrySelectorWrapperUi = styled.div<{
  styles?: CSSProp
}>`
  position: relative;
  ${({ styles }) => styles}
`
